import React from 'react';
import { configureStore } from 'redux/store';
import Root from 'containers/Root';
import { IntlProvider } from 'react-intl';
import en_GB from 'intl/en-GB.json';

import { queryByAttribute, queryAllByAttribute, fireEvent, within } from '@testing-library/react';
import { createMemoryHistory } from 'history';
import { Router } from 'react-router-dom';

export const history = createMemoryHistory();

const RootProvider = ({ store, state = {}, children }) => {
  const rootStore = store || configureStore(state);

  return (
    <Root store={rootStore}>
      <Router history={history}>
        <IntlProvider locale="en" messages={en_GB}>
          {children}
        </IntlProvider>
      </Router>
    </Root>
  );
};

const getById = queryByAttribute.bind(null, 'id');
const getByName = queryByAttribute.bind(null, 'name');
const getAllByName = queryAllByAttribute.bind(null, 'name');
const getAllByValue = queryAllByAttribute.bind(null, 'value');

const joinExpectedValues = (values) =>
  Object.keys(values)
    .map((key) => `${key}=${values[key]}`)
    .join('&');

const _focus = (input) => {
  fireEvent.focus(input);

  fireEvent.keyDown(input, {
    key: 'ArrowDown',
    keyCode: 40,
    code: 40,
  });
};

const reactSelectSelectOption = async (
  container,
  { name, value, typeBefore = false, triggerFocus = true }
) => {
  const { findByTestId } = within(container);

  const input = getById(container, name);

  if (typeBefore) fireEvent.change(input, { target: { value } });

  if (triggerFocus) _focus(input);

  const menu = await findByTestId(`${name}_menu`);

  const { findByText: findByTextInMenu } = within(menu);

  fireEvent.click(await findByTextInMenu(value));
};

export {
  getById,
  getByName,
  getAllByName,
  getAllByValue,
  joinExpectedValues,
  reactSelectSelectOption,
};

export default RootProvider;
